import script from "./CinemaChoiceOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CinemaChoiceOverlay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__